// src/React/src/sagas/agentQuerySagas.ts
import { PayloadAction } from '@reduxjs/toolkit'
import { call, put, takeLatest } from 'redux-saga/effects'
import * as actions from '../actions/agentQueryActions'
import { SendMessagePayload } from '../actions/agentQueryActions'
import { AgentQueryRequest } from '../api/agentQuery'
import { ApiServiceInstance } from '../services/ApiService'

export const LS_SESSION_ID = 'orderAssistant_sessionId'
export const LS_MESSAGES = 'orderAssistant_messages'
export const LS_TIMESTAMP = 'orderAssistant_timestamp'

export function* sendMessageSaga(action: PayloadAction<SendMessagePayload>): Generator {
  const { prompt, sessionId } = action.payload
  const request: AgentQueryRequest = { prompt, sessionId }

  try {
    const response = (yield call(ApiServiceInstance.post, 'v1/agent/query', request)) as any
    const { answer, sessionId: newSessionId } = response.data

    yield put(actions.messageReceived({ answer, sessionId: newSessionId }))

    localStorage.setItem(LS_SESSION_ID, newSessionId)
    localStorage.setItem(LS_TIMESTAMP, String(Date.now()))
  } catch (e) {
    const status = (e as any)?.response?.status
    if (status === 400 || status === 404) {
      localStorage.removeItem(LS_SESSION_ID)
      localStorage.removeItem(LS_MESSAGES)
      localStorage.removeItem(LS_TIMESTAMP)
      yield put(actions.messageError('Your session expired. Starting a new conversation.'))
    } else {
      yield put(actions.messageError('Something went wrong. Please try again.'))
    }
  }
}

export default function* root() {
  yield takeLatest(actions.sendMessage, sendMessageSaga)
}
